import { useSelector } from 'react-redux';

export function useBoligmappaPlusSubscriptionStatus() {
  const subscriptionStatus = useSelector(
    (state) => state?.auth?.user?.isSubscribeToBoligmappaPlus
  );
  return subscriptionStatus;
}
